"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spinnerDarkTheme = exports.spinnerClassicTheme = exports.spinnerThemeNamespace = void 0;

var _theme = require("@tablekit/theme");

var spinnerThemeNamespace = '@tablekit/spinner';
exports.spinnerThemeNamespace = spinnerThemeNamespace;
var spinnerClassicTheme = {
  fillColor: (0, _theme.color)('primary2')
};
exports.spinnerClassicTheme = spinnerClassicTheme;
var spinnerDarkTheme = spinnerClassicTheme;
exports.spinnerDarkTheme = spinnerDarkTheme;